import { render } from "./EmailHistory.vue?vue&type=template&id=13e9f126"
import script from "./EmailHistory.vue?vue&type=script&lang=js"
export * from "./EmailHistory.vue?vue&type=script&lang=js"

import exportComponent from "/app/tmp/blackhall/V3/v2026.27.r2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__